import { createFileRoute } from '@tanstack/react-router'
import { InstancePacksPage } from '@/features/packs/instance-packs-page'

type PacksSearch = {
  tab?: 'my-packs' | 'discover'
}

export const Route = createFileRoute('/_authenticated/instances/$instanceId/packs/')({
  validateSearch: (search: Record<string, unknown>): PacksSearch => {
    const tab = search.tab
    if (tab === 'my-packs' || tab === 'discover') {
      return { tab }
    }
    return {}
  },
  component: InstancePacksPage,
})
